import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 18 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.5 4H17V2.5a.5.5 0 1 0-1 0V4h-1V2.5a.5.5 0 1 0-1 0V4h-.5a.5.5 0 0 0-.5.5V6a2.5 2.5 0 0 0 2 2.45V12a1 1 0 0 1-2 0v-1.5C13 9.122 11.879 8 10.5 8H10V2a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v13H.25a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25H10V9h.5c.827 0 1.5.673 1.5 1.5V12c0 1.103.898 2 2 2 1.102 0 2-.897 2-2V8.45A2.5 2.5 0 0 0 18 6V4.5a.5.5 0 0 0-.5-.5ZM9 15H2V2c0-.551.449-1 1-1h5c.551 0 1 .449 1 1v13Zm8-9c0 .827-.673 1.5-1.5 1.5S14 6.827 14 6V5h3v1Zm-9.5-.5h-.528l.496-1.324A.5.5 0 0 0 7 3.5H4.5a.499.499 0 0 0-.464.314l-1 2.5A.5.5 0 0 0 3.5 7h.61l-.595 2.379c-.122.484.475.836.838.474l3.5-3.5A.5.5 0 0 0 7.5 5.5ZM4.923 7.87l.312-1.25A.5.5 0 0 0 4.75 6h-.512l.6-1.5h1.44l-.496 1.324c-.103.274.045.676.51.676l-1.37 1.37Z" }, null, -1)
  ]))]))
}
export default { render: render }